import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { generarReporteCapacidadB_jumio } from "../api/generarReporteCapacidadB_jumio";
import { jsPDF } from "jspdf";
import Modal from 'react-bootstrap/Modal';
import parse from 'html-react-parser';
import "./print.css";
import "./style.css";


const CapacidadEndeudamientoSolvenciaB_Jumio = () => {

  const componentRef = useRef(null);
  const isRunned = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(null);
  const [showMessage, setShowMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [validateCurpCpv, setValidateCurpCpv] = useState(false);

  const [imagenFront, setImagenFront] = useState("");
  const [imagenBack, setImagenBack] = useState("");

  /*Varible de tarjeta de inicio*/
  const [usuarioTipo, setUsuarioTipo] = useState("")

  /*variables reporte*/
  const [usuarioVigencia, setUsuarioVigencia] = useState("");
  const [usuarioCPV, setusuarioCPV] = useState(params.get("i"));

  const date = new Date();
  const formattedDate = date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');

  /*Variables Capacidad de Endeudamiento*/
  const [usuarioImagenSegmentos, setUsuarioImagenSegmentos] = useState('');
  const [usuarioCapacidadEndeudamiento, setUsuarioCapacidadEndeudamiento] = useState('');
  const [usuarioActividadInformal, setUsuarioActividadInformal] = useState("");
  const [usuarioActividadInformalPorcentaje, setUsuarioActividadInformalPorcentaje] = useState("");
  const [usuarioCapacidadDeAhorro, setUsuarioCapacidadDeAhorro] = useState("");
  const [usuarioCapacidadDeAhorroPorcentaje, setUsuarioCapacidadDeAhorroPorcentaje] = useState("");
  const [usuarioApalancamientoFinanciero, setUsuarioApalancamientoFinanciero] = useState("");
  const [usuarioApalancamientoPorcentaje, setUsuarioApalancamientoPorcentaje] = useState("");
  const [usuarioRealizacionTiempo, setusuarioRealizacionTiempo] = useState("");
  const [usuarioTendencia, setUsuarioTendencia] = useState("");
  const [usuarioIntervaloMax, setUsuarioIntervaloMax] = useState("");
  const [usuarioIntervaloMin, setUsuarioIntervaloMin] = useState("");

  /*Footer */
  const [usuarioFooterFecha, setusuarioFooterFecha] = useState("");
  /*Observaciones*/
  const [usuarioObservaciones, setusuarioObservaciones] = useState("");
  /*Perfil Financiero*/
  const [usuarioEdad, setUsuarioEdad] = useState("");
  const [usuarioOcupacion, setUsuarioOcupacion] = useState("");
  const [usuarioNivelDeEstudios, setUsuarioNivelDeEstudios] = useState("");
  const [usuarioAntiguedadCrediticia, setUsuarioAntiguedadCrediticia] = useState("");
  const [usuarioNumeroCreditos, setUsuarioNumeroCreditos] = useState("");
  const [usuarioDeudaTotal, setUsuarioDeudaTotal] = useState("");
  const [usuarioDivsIngresos, setUsuarioDivsIngresos] = useState([]);

  const [usuarioDivsEgresos, setUsuarioDivsEgresos] = useState("");
  const [usuarioDivsDeudaMensual, setUsuarioDivsDeudaMensual] = useState("");
  const [usuarioIngresoMensual, setUsuarioIngresoMensual] = useState("");
  const [usuarioGastoMensual, setUsuarioGastoMensual] = useState("");
  const [usuarioDeudaMensual, setUsuarioDeudaMensual] = useState("");
  const [usuarioTextoScoreCrediticio, setUsuarioTextoScoreCrediticio] = useState("");
  const [usuarioScoreCrediticioCaracteristica, setUsuarioScoreCrediticioCaracteristica] = useState("");

  const [cardSvgP, setCardSvgP] = useState("");
  const [logoDPR, setLogoDPR] = useState("");
  const [check_deepBlue, setCheck_deepBlue] = useState("");
  const [cardSvgBlack, setCardSvgBlack] = useState("");
  const [qr, setQr] = useState("");

  const handleClose = () => {
    setShow(false);
  }

  useEffect(() => {

    if (isRunned.current) return;
    isRunned.current = true;

    async function createSession() {

      localStorage.clear();

      if (params.get("i") == null) {

        setLoading(false);
        setModalShow(false);
        setShow(true);
        setShowStatus(500);
        setShowMessage("Error al obtener el cpv")

      } else {

        setLoading(true);

        const dataImgRepo = await generarImagenReporte();

        const cardSvgPStr =
          "data:image/png;base64," + dataImgRepo.cardSvgP + "";

        const logoDPRStr =
          "data:image/png;base64," + dataImgRepo.logoDPR + "";

        const check_deepBlueStr =
          "data:image/png;base64," + dataImgRepo.check_deepBlue + "";

        const cardSvgBlackStr =
          "data:image/png;base64," + dataImgRepo.cardSvgBlack + "";

        const qrStr =
          "data:image/png;base64," + dataImgRepo.qr + "";


        setLogoDPR(logoDPRStr);
        setCardSvgP(cardSvgPStr);
        setCheck_deepBlue(check_deepBlueStr);
        setCardSvgBlack(cardSvgBlackStr);
        setQr(qrStr);

        const objCpv = {
          curpValidate: params.get("i"),
        };

        const response = await generarReporteCapacidadB_jumio(objCpv);

        if (response.status === 200) {

          setUsuarioEdad(response.edad);
          setUsuarioOcupacion(response.ocupacion);
          setUsuarioNivelDeEstudios(response.nivelEstudios);
          setUsuarioAntiguedadCrediticia(response.antiguedadCrediticia);
          setUsuarioNumeroCreditos(response.numeroCreditos);
          setUsuarioDeudaTotal(response.deudaTotal);
          setUsuarioVigencia(response.vigencia);

          const actividadInformalStr =
            "data:image/png;base64," + response.actividadInformal + "";

          setUsuarioActividadInformal(actividadInformalStr);
          setUsuarioActividadInformalPorcentaje(response.porcentajeActividadInformal);

          const capacidadDeAhorroStr =
            "data:image/png;base64," + response.capacidadAhorro + "";
          setUsuarioCapacidadDeAhorro(capacidadDeAhorroStr);
          setUsuarioCapacidadDeAhorroPorcentaje(response.porcentajeCapacidadAhorro);

          const apalancamientoFinancieroStr =
            "data:image/png;base64," + response.apalancamientoFinanciero + "";
          setUsuarioApalancamientoFinanciero(apalancamientoFinancieroStr);
          setUsuarioApalancamientoPorcentaje(response.porcentajeApalancamientoFinanciero);

          const imagenSegmentosStr =
            "data:image/png;base64," + response.imagenSegmentos + "";
          setUsuarioImagenSegmentos(imagenSegmentosStr);

          setUsuarioCapacidadEndeudamiento(response.capacidadEndeudamiento);

          setUsuarioTextoScoreCrediticio(response.textoScoreCrediticio);

          setUsuarioScoreCrediticioCaracteristica(response.scoreCrediticioConCaracteristica);

          setUsuarioIngresoMensual(response.ingresoMensual);

          setUsuarioGastoMensual(response.gastoMensual);

          setUsuarioDeudaMensual(response.deudaMensualFooter);

          setUsuarioTendencia(response.tendenciaBoton);

          setUsuarioIntervaloMax(response.interMax);

          setUsuarioIntervaloMin(response.interMin);

          handlePrint();


        } else {

          setLoading(false);
          setShow(true);
          setShowStatus(response.status);
          setShowMessage(response.message);

        }

        setLoading(false);

      }
    }

    createSession();

  }, []);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    print: async () => {
      const doc = new jsPDF();
      doc.html(componentRef.current, {
        html2canvas: {
          removeContainer: true,
          scale: 0.19,
        },
        margin: 5,
        x: -1,
        async callback(doc) {
          await doc.save('CapacidadEndeudamiento _' + usuarioCPV + '_' + formattedDate);
        },
      });
    },

  });

  return (
    <>
      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className='backGroudModal'>
          <div className='msjTitleModalDiv'>Error {showStatus}</div>
          <div className='msjErrorModal'>{showMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <button className='button_P2' onClick={handleClose}>
            <span className='txtButton_P2'>Regresar</span>
          </button>
        </Modal.Footer>
      </Modal>

      <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
        <div
          className=" animate__animated animate__fadeIn"
          ref={componentRef}
          style={{ display: "block", width: "1070px", border: "none" }}
        >
          <div className="relativeCSS">
            <style type="text/css" media="print">
              {
                "@page {  size: A4;  }"
              }
            </style>

            {/* hoja 1 */}

            {/* AQUI VA LA MAGIA DE LA FAX */}
            <br />
            <div className="container-fluid">
              <section className="row">
                <div className="col-6">
                  <article className="identify-card ">
                    <aside className="account-detail gray w25">
                      <section className="detail-image">
                        <img src={logoDPR} alt="" />
                      </section>
                      <div className="detail-background">
                        <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                      </div>
                    </aside>
                    <article className="middle-section">
                      <title className="title">
                        <div className="left">IDe</div>
                        <div className="right">
                          <strong>ERC Financiero</strong>
                          <br />
                          <span>Credencial Verificada</span>
                        </div>
                      </title>
                      <section className="info-section ">
                        <div className="subtitle">
                          <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                          <h2>Solvencia</h2>
                          <h4>{usuarioTipo}</h4>
                        </div>
                        <hr className="bordeHr" />
                        <ul className="pNone ">
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>AUTENTICACIÓN &nbsp; DE IDENTIDAD</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>INFORMACIÓN &nbsp; REQUERIDA</span>
                          </li>
                          <li>
                            <img src={check_deepBlue} alt="checkBlue" />
                            <span>REFERENCIAS &nbsp; BANCARIAS</span>
                          </li>
                        </ul>
                        <div className="expires">
                          <span className="text-lg">Vence:&nbsp;{usuarioVigencia}</span>
                        </div>
                      </section>
                    </article>
                    <article className="right-section">
                      <div className="detail-finance identity">
                        <img src={cardSvgBlack} alt="" />
                      </div>
                      <section className="qr-code">
                        <img className="qrSize" src={qr} alt="" />
                        <span className="cpv__text">CPV: {usuarioCPV}</span>
                      </section>
                      <section className="verify">
                        <img src={cardSvgP} alt="" />
                      </section>
                    </article>
                  </article>

                  <div className="titleCard mt-3">VERIFICACIÓN &nbsp; DE AUTENTICIDAD</div>
                  <div className="card verify-note">
                    <p className="f12"> El resultado obtenido  <strong> no es válido </strong> si la fecha en la parte superior izquierda de este
                      <strong> Reporte </strong> se encuentra <strong> vencida </strong> . Para &nbsp; comprobar su autenticidad escanee &nbsp; el código QR o ingrese directamente el código
                      <strong> CPV </strong> en <strong> www.midpr.net/verificar </strong> .
                    </p>
                  </div>
                  <small className="footer-note">
                    *Notifique si este Reporte es falso al +52 5571605526 y/o en www.midpr.net
                  </small>
                </div>
                <div className="col-6">
                  <h4 className="text-center">Capacidad de Ahorro</h4>
                  <p className="f12">
                    Este <strong>&nbsp; Reporte </strong>
                    da constancia de la calificación resultante de la aplicación de manera
                    <strong> completa y concluyente </strong>
                    de esta Evaluación &nbsp; Remota Confiable (ERC&nbsp;) realizada por el
                    <strong> Aplicante </strong>
                    , obteniendo los siguientes resultados:
                  </p>
                  <div className="titleCard">CAPACIDAD &nbsp; DE &nbsp; AHORRO</div>
                  <article className="card result">

                    <section className="graph-half-circle mb-3">
                      <img src={usuarioImagenSegmentos} alt="" className="Result__graph ComprobateImagen--sizing" />
                      <span className="percent-graph CapacidadEndeudamiento__percent">{usuarioCapacidadEndeudamiento}</span>
                    </section>
                    <div className="d-flex justify-content-center  align-items-center">
                      <button type="button" className="btn gray ">MXN ${usuarioIntervaloMin} - MXN ${usuarioIntervaloMax}</button>
                    </div>
                  </article>
                  <small className="footer-note ">
                    *La interpretación de este resultado obtenido es responsabilidad exclusiva de quien lo recibe.
                  </small>
                </div>
              </section>

            </div>

            <div className="container-fluid">
              <div className="row">
                <div className="col-6 ">
                  <div className="titleCard mt-3">PERFIL &nbsp;FINANCIERO</div>
                  <section className="card  financial-profile ">
                    <table className="f12">
                      <thead>
                        <tr>
                          <th>Edad
                            <br />
                            Real</th>
                          <th>Ocupación
                            <br />
                            Declarada</th>
                          <th>Nivel de estudios
                            <br />
                            Declarado</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{usuarioEdad}</td>
                          <td className="py-4">{usuarioOcupacion}</td>
                          <td>{usuarioNivelDeEstudios}</td>
                        </tr>
                        <tr>
                          <td>{usuarioAntiguedadCrediticia}</td>
                          <td className="py-4">{usuarioNumeroCreditos}</td>
                          <td>{usuarioDeudaTotal}</td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th>Antigüedad crediticia
                            <br />
                            BC</th>
                          <th>Número de créditos
                            <br />
                            BC</th>
                          <th>Deuda total
                            <br />
                            BC</th>
                        </tr>
                      </tfoot>
                    </table>

                  </section>
                  <br />
                  <table className="three-graphics">
                    <tbody>
                      <tr>
                        <td> {/* define una celda en una tabla*/}
                          <div className="graph-half-circle position-relative"> {/* crea un elemento, y define la forma del circulo */}
                            <img src={usuarioActividadInformal} alt="" className="temporal" /> {/* ESpecifica la fuente de la imagen */}
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{usuarioActividadInformalPorcentaje}</span> {/*Recibe la informacion de la variable actividad informal*/}
                          </div>
                          <span className="label-graph">
                            Actividad
                            <br />
                            informal
                          </span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioCapacidadDeAhorro} alt="" className="temporal" />
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{usuarioCapacidadDeAhorroPorcentaje}</span> {/* El valor de este porcentaje está determinado por la variable usuarioCapacidadDeAhorroPorcentaje*/}
                          </div>
                          <span className="label-graph">
                            Capacidad de
                            <br />
                            Endeudamiento
                          </span>
                        </td>
                        <td>
                          <div className="graph-half-circle position-relative">
                            <img src={usuarioApalancamientoFinanciero} alt="" className="temporal" />
                            <span className="percent-graph SocioEconomico__percents--trheeGraph">{usuarioApalancamientoPorcentaje}</span>
                          </div>
                          <span className="label-graph">
                            % de Aportacion a
                            <br />
                            Deuda Mensual
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-center align-items-center">
                    {parse(usuarioTendencia)}
                  </div>

                  <small className="footer-note">*Consulte definiciones de estas métricas en www.midpr.net/resultados</small>

                  <p className="f12 mt-2">
                    Esta <strong>&nbsp;ERC&nbsp;</strong>  fue realizada de manera automatizada a través de un dispositivo digital propiedad del
                    <strong> Aplicante </strong> . Durante el proceso, se registraron una serie de datos de carácter personal que fueron analizados, validados y/o verificados que permitieron, posterior al análisis de la información, la obtención del dictamen presentado con respecto a la
                    <strong> congruencia o incongruencia </strong>  de estos de manera integral.
                  </p>
                </div>
                <div className="col-6 ">
                  <div className="titleCard mt-3">ÁREAS &nbsp; EVALUADAS</div>
                  <div className="card custom-graph-solvency container-fluid f12">
                    <div className="inner-row top row">
                      <div className="col-4">
                        <h7>Ingreso mensual</h7>
                      </div>
                      <div className="col-4">
                        <h7>Gasto mensual</h7>
                      </div>
                      <div className="col-4">
                        <h7>Deuda Mensual BC</h7>
                      </div>
                    </div>
                    <div className="inner-row middle  ">
                      {usuarioDivsIngresos}

                      {usuarioDivsEgresos}

                      {usuarioDivsDeudaMensual}
                    </div>
                    <div className="inner-row bottom row  ">
                      <div className="col-4"><strong>{usuarioIngresoMensual}</strong></div>
                      <div className="col-4"><strong>{usuarioGastoMensual}</strong></div>
                      <div className="col-4"><strong>{usuarioDeudaMensual}</strong></div>
                    </div>
                    <br />
                  </div>
                  <small className="footer-note">*Consulte al reverso de este Reporte las imágenes recabadas.</small>
                  <br />
                  <br />
                  <div className="d-flex justify-content-center  align-items-center">
                    {/*<button type="button" className="btn gray"><span className="label-msg">{`Tiempo de realización: 50 ${usuarioRealizacionTiempo}`}</span></button>*/}
                  </div>

                  <div className="titleCard mt-3">SCORE &nbsp; CREDITICIO</div>
                  <section className="card family-income f12">
                    {usuarioTextoScoreCrediticio}
                    <h5 className="text-center mt-2">{usuarioScoreCrediticioCaracteristica}</h5>
                  </section>

                </div>
              </div>
            </div>

            <small className="footer-note">*Consulte al reverso de este Reporte DPR nuestra Política de Privacidad y/o en www.midpr.net/privacidad</small>


            <section className="note-gray note-emit">
              <p>
                Se emite el presente Reporte el {formattedDate} en calidad de
                <strong> INFORMACIÓN &nbsp; CONFIDENCIAL </strong>
              </p>
            </section>
            <div className="titleCard">AVISO&nbsp;LEGAL</div>
            <div class="card legal-advise">

              <p className="f12 Word__Spacing">La <strong>Calificación</strong> realizada de manera remota por el <strong>Aplicante</strong>, a la que hace referencia este <strong>Reporte</strong>, fue realizada a solicitud directa del <strong>Destinatario</strong>. Antes y durante la <strong>Calificación</strong>, fue autenticada la identidad del <strong>Aplicante</strong> y se registraron una serie de datos e información de carácter personal con su autorización expresa, lo cual permitió emitir una Evaluación Remota Confiable (ERC&nbsp;). El <strong>&nbsp; Destinatario</strong> acepta que todos los datos contenidos en el presente <strong>Reporte</strong> son confidenciales y de interés exclusivo y privado, que es compartida únicamente con el propósito que ha sido previamente informado por el <strong>Destinatario</strong> y que ha autorizado por el <strong>Aplicante</strong> previo a la aplicación de la <strong>Calificación</strong>. El <strong>Aplicante</strong> y/o el <strong>Destinatario</strong> de este Reporte aceptan de conformidad la responsabilidad sobre cualquier uso indebido o ilegal de este documento y su contenido, así como todos los términos y condiciones descritos al reverso. <strong>Una vez entregado este Reporte al Destinatario, el Fabricante se deslinda de toda responsabilidad sobre su interpretación, divulgación y uso</strong>.</p>

            </div>
            <br />
            <p class="txt-center f12"><strong>Business &nbsp; Prey SA de CV</strong> hace referencia que con número de registro <strong>DGSP&nbsp;/369-19/3919</strong>, está autorizada por la <strong>SSPC&nbsp;/DGSP</strong> para la aplicación de Pruebas y Evaluación de Control de Confianza de conformidad con los <strong>Lineamientos y Criterios Técnicos &nbsp;</strong> publicados en el Diario Oficial de la Federación (DOF) el <strong>28 de abril de 2020</strong>.</p>


            {/* hoja 2 */}

            <br />
            <br />
            <br />
            <br />
            <br />
            <br />


            <h5>OBSERVACIONES</h5>
            <div className="card observations empty">
              <p>{usuarioObservaciones}</p>
            </div>


            <div className="div-vertical">
              <div className="div-horizontal" id="div1">


                <div className="cardLeft">
                  <div className="subTitleCardTwo">
                    <b>Business Prey SA de CV (BP)</b>, Fabricante exclusivo en la
                    República Mexicana para DPR, con número de registro
                    autorización DGSP/369-19/3919 expedido por la Dirección
                    General de Seguridad Privada (DGSP) de la Secretaría de
                    Seguridad y Protección Ciudadana (SSPC) para la aplicación
                    de pruebas de evaluación de control de confianza en
                    términos de los Lineamientos y Criterios Técnicos que
                    deberán cumplir las Empresas de Seguridad Privada bajo la
                    Modalidad VI, previsto en el artículo 15 de la Ley Federal
                    de Seguridad Privada (LFSP), publicados con fecha de 28 de
                    abril de 2020, en el Diario Oficial de la Federación (DOF)
                    y en cumplimiento con lo dispuesto por los artículos 1, 3,
                    6, 7, 8, 12 y 14 de la Ley Federal de Protección de Datos
                    Personales en Posesión de los Particulares emite el
                    resultado de la presente Evaluación Remota Confiable
                    (ERC).
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Aplicación de la Evaluación ERC</b> La presente ERC fue
                    acotada a una Área de Interés específica mediante un
                    proceso remoto que el Aplicante aceptó de manera expresa y
                    totalmente voluntaria someterse a la evaluación, con la
                    finalidad de ser calificado en diversas Temáticas con lo
                    que se estimó el Resultado Obtenido, conforme a la
                    metodología y marcos de referencia establecidos por DPR
                    para tal efecto. Para la realización de la ERC, el
                    Aplicante utiliza dispositivos electrónicos de su
                    propiedad, fuera del control del Fabricante, por lo que se
                    aplican avanzados métodos de validación y verificación de
                    datos para asegurar su veracidad y autenticidad.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Declaración de Veracidad</b> Esta evaluación ERC puede o no
                    formar parte de un proceso de certificación que incluye
                    una Prueba DPR. Al presentar esta ERC, el Aplicante acepta
                    y se somete a una declaración bajo protesta de decir
                    verdad de proporcionar información fidedigna. La veracidad
                    de la misma puede ser comprobada durante o posteriormente.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Proceso de Calificación</b> La ERC incluye un conjunto de
                    Áreas Evaluadas que incluyen Temas de Interés que son
                    requisitados para obtener un Resultado y un Dictamen. La
                    información que se recaba y se procesa durante la
                    evaluación se describen en este Reporte y corresponden a
                    una dimensión particular de datos adquiridos del
                    Aplicante.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Interpretación de los Resultados</b> Esta ERC incluye los
                    diversas Temas de Interés para obtener un Resultado
                    Obtenido y el Dictamen de veracidad o congruencia, que son
                    exclusivamente un parámetro medido en porcentaje y/o una
                    valoración cualitativa correspondientemente, por lo que no
                    existe un valor o magnitud específica que sea aprobatoria
                    o no aprobatoria. Es responsabilidad exclusiva del
                    Destinatario establecer el umbral mínimo o máximo
                    esperado, para la determinación de la aceptación del
                    Aplicante o para la permanencia de acuerdo a los
                    Resultados Obtenidos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Emisión del Certificado</b> Al culminar de manera concluyente
                    esta ERC, el resultado se procesa en un periodo máximo de
                    24 horas. El resultado, datos y dictamen descrito en este
                    Reporte, es sellado digitalmente mediante un Certificado
                    Personal Verificable (CPV) de forma numérica o en QR que
                    puede ser utilizado para confirmar la vigencia y
                    autenticidad del mismo en la página
                    www.midpr.net/verificar. Este Reporte deberá ser
                    considerado como falso, si la consulta no resulta en la
                    leyenda de “Verificado”.
                  </div>
                </div>
                <div>
                  <div className="subTitleCardTwo">
                    <b>Privacidad de Datos Personales</b> Para efectos del
                    cumplimiento del artículo 9 de la Ley Federal de
                    Protección de Datos Personales en Posesión de los
                    Particulares (LFPDPPP), el Aplicante de la ERC manifiesta
                    expresamente que otorgó su consentimiento para el
                    tratamiento de sus datos personales sensibles, durante los
                    procedimientos de recopilación y procesamiento, aceptando
                    los términos y condiciones para tales efectos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de las Marcas</b> DPR y las marcas asociadas son marcas
                    registradas, protegida por los artículos 88 y 142 de la
                    Ley de Propiedad Industrial (LPI), así como el convenio de
                    París para efectos internacionales. El consumo o
                    adquisición de cualquiera de los servicios vinculados a
                    DPR y/o proporcionados por el Fabricante, no confieren al
                    Aplicante y/o al Destinatario el derecho de uso de las
                    marcas de DPR en ningún contexto y/o formato, ya que al
                    hacerlo podría resultar en actividad fraudulenta y ser
                    clasificado como un delito. La marca, propiedad
                    intelectual o cualquier otro tipo de secreto industrial
                    contenido en este Reporte, no autoriza el uso, explotación
                    comercial, venta, reproducción o distribución de dicha
                    información.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>Uso de Información por Terceros</b> Al realizar la ERC, el
                    Aplicante autoriza la entrega del resultado obtenido al
                    Destinatario para el uso particular que ambos hayan
                    acordado. Para el caso exclusivo de Elementos de Seguridad
                    Privada, la entrega de este Reporte a la DGSP, se hará
                    conforme a lo previsto en el artículo 9 de los citados
                    Lineamientos y Criterios Técnicos.
                  </div>

                  <div className="subTitleCardTwo">
                    <b>
                      En DPR estamos a favor de la confianza profesional, la
                      honestidad y transparencia, la privacidad de datos
                      personales, la equidad de género, la inclusión financiera
                      y digital, la igualdad de oportunidades y la no
                      discriminación.
                    </b>
                  </div>

                  <div className="card evaluated-areas tipo-d borderCard">
                    <div className="titleContainerSinBorder">
                      TEMAS DE INTERÉS
                    </div>
                    <div className="subTitleCardTwo">
                      <ul className="espacio-ul-left">
                        <li>
                          <strong>Ingreso Mensual:</strong> Ocupación económica, ingreso comprobable, ingreso no comprobable, comprobantes de ingresos.
                        </li>
                        <li>
                          <strong>Gasto Mensual:</strong> Alimentación, transporte, renta, agua, electricidad, gas, TV de paga, Internet fijo, teléfono, celular, enseñanza,salud, esparcimiento, ropa, cuidado del hogar, cuidado personal, combustible, restaurantes, viajes, otros.
                        </li>
                        <li>
                          <strong>Buró de Crédito:</strong> Score crediticio, deuda mensual, deuda total, antigúedadcrediticia, créditos bancarios, créditos no bancarios comportamiento crediticio.
                        </li>
                        <li>
                          <strong>Referencias bancarias:</strong> Número de Identidad Nacional (verificado), número celular (validado), correo electrónico (validado), tipo de relación (no personal), domicilio particular (validado).
                        </li>
                      </ul>
                    </div>
                  </div>
                  <br />
                  <br />
                  <div className="note-gray">
                    <p>
                      <strong>Business Prey SA de CV</strong> con domicilio en
                      Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                      DPR. Para mayor información llame al +52 5571605526 o
                      visite el sitio <strong>www.midpr.net</strong>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CapacidadEndeudamientoSolvenciaB_Jumio